<template>
  <!-- 关联用--普本专业 -->
  <!--用于父组件中展示的UI-->
  <el-row>
     <!-- 单选 -->
      <el-button
        :plain="true"
        @click="openDialog"
        class="relevancy_btn"
        :disabled="isEdit"
        ><el-icon><Plus /></el-icon>&nbsp;&nbsp;{{
          selectData.length > 0
            ? "已选择(" + selectData[0].name + ")专业"
            : "点击选择"
        }}</el-button
      >
  </el-row>
  <el-dialog
    :show-close="false"
    v-model="tableDialog"
    :close-on-click-modal="false"
    :fullscreen="false"
    title="选择院校所属专业"
    width="850px"
    append-to-body
  >
    <div class="table_dialog">
      <el-table
        class="table"
        v-loading="loading"
        ref="multipleTableRef"
        :data="tableData"
        max-height="500px"
        border
        :header-cell-style="{ background: '#f5f7fa' }"
        style="width: 100%; margin-top: -20px"
        :header-cell-class-name="cellClass"
        @select="select"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          prop="name"
          label="专业名称"
          align="left"
          min-width="200"
          :show-overflow-tooltip="true"
          inputSearch="true"
        >
          <template #header>
            <el-popover placement="bottom" :width="300" trigger="click">
              <template #reference>
                <div>
                  <span class="search-title">专业名称</span>
                  <el-icon><Search /></el-icon>
                </div>
              </template>
              <el-input
                v-model="nameInput"
                class="m-2"
                placeholder="请输入专业名称搜索"
                size="large"
                clearable
                @clear="getMarjorData('search')"
              >
                <template #suffix>
                  <el-icon @click="getMarjorData('search')" clearable
                    ><Search
                  /></el-icon>
                </template>
              </el-input>
            </el-popover>
          </template>
          <template #default="scope">
            <span :class="scope.row.name ? '' : 'gray'">{{
              scope.row.name ? scope.row.name : "未设置"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="year"
          label="专业年份"
          width="240"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template #header>
            <el-popover placement="bottom" :width="200" trigger="click">
              <template #reference>
                <div>
                  <span class="search-title">专业年份</span>
                  <el-icon><ArrowDown /></el-icon>
                </div>
              </template>
              <el-select
                v-model="recentYear"
                @change="yearChange"
                placeholder="请选择"
                clearable
                filterable
              >
                <el-option
                  v-for="item in yearsSel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-popover>
          </template>
          <template #default="scope">
            <span :class="scope.row.year ? '' : 'gray'">{{
              scope.row.year ? scope.row.year + "年" : "未设置"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="majorCategoryName"
          label="所属专业类别"
          width="240"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template #header>
            <el-popover placement="bottom" :width="200" trigger="click">
              <template #reference>
                <div>
                  <span class="search-title">专业类别</span>
                  <el-icon><ArrowDown /></el-icon>
                </div>
              </template>
              <el-select
                v-model="categoryValue"
                class="m-2"
                placeholder="请选择专业类别"
                size="large"
                clearable
                filterable
                @change="getMarjorData('search')"
              >
                <el-option
                  v-for="item in majorCategorySel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="choose_bom">
      <span style="margin-right: 10px" v-if="selectData.length > 0"
        >已选择[
        <b class="select_red" style="font-size: 16px">{{
          selectData[0].name
        }}</b>
        ]专业</span
      >
      <span style="margin-right: 10px" v-else>请先选择专业</span>
      <div style="font-size: 16px; float: right">
        <el-button @click="closeDialog($event)" size="medium">取消</el-button>
        <el-button size="medium" type="primary" @click="clickTrue($event)" plain
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getMajorPtSchoolList } from "network/pbMajor.js";
import { getMajorCategory } from "network/majorCategory.js";
import { reactive, onMounted, toRefs, ref, toRaw, watch, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
export default {
  name: "MajorTable",
  props: {
    isEdit: Boolean,
    majorId: Number,
  },
  components: {},
  emits: {
    "change-major": null,
  },
  setup(props, { emit }) {
    // 监听props
    watch(props, (newProps) => {
      //  获取当前编辑对象的 院校id
      const propsData = toRaw(newProps);
      data.majorId = propsData.majorId;
      getMarjorData(""); //请求普本专业列表数据
    });

    const multipleTableRef = ref();
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      tableData: [],
      // 表格是否在加载中
      loading: true,
      nameInput: "", //筛选 普本专业名称
      recentYear: "", //筛选 年份
      yearsSel: [], //年份下拉选项
      categoryValue: "", //筛选 专业类别
      majorCategorySel: [], //专业类别下拉选项
      tableDialog: false,
      selectData: [], //选中数据
    });
    //挂载后调用函数获取项目数据
    onMounted(() => {
      getMajorCategoryList(); //获取专业类别
      var year = new Date().getFullYear(); //获取当前年
      initSelectYear(year);
    });

    // 格式化年份下拉框
    function initSelectYear(year) {
      data.yearsSel = [];
      for (let i = 0; i < 16; i++) {
        data.yearsSel.push({ value: year - i, label: year - i + "年" });
      }
    }
    // 选择年份
    const yearChange = (value) => {
      data.recentYear = value;
      getMarjorData("search");
    };
    //获取专业类别下拉
    function getMajorCategoryList() {
      getMajorCategory(true)
        .then((res) => {
          if (res.code == 1) {
            data.majorCategorySel = res.result;
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 去掉全选按钮操作
    const cellClass = (row) => {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    };
    //点击选择 打开表格
    const openDialog = () => {
      if (toRaw(props).majorId == null) {
        data.tableDialog = true;
        data.majorId = null;
        getMarjorData(""); //请求普本院校列表数据
      } else {
        data.tableDialog = true;
        if (multipleTableRef.value) {
          changeSelRow();
        } else {
          nextTick(() => {
            changeSelRow();
          });
        }
      }
    };
    // 表格初始化选中
    function changeSelRow() {
      for (var i = 0; i < toRaw(data.tableData).length; i++) {
        if (data.majorId == toRaw(data.tableData)[i].id) {
          multipleTableRef.value.toggleRowSelection(
            toRaw(data.tableData)[i],
            true
          );
          data.selectData.push(toRaw(data.tableData)[i]);
        }
        data.loading = false;
      }
    }
    // 表格单选行处理
    const select = (selection, row) => {
      if (selection.length == 0) {
        data.selectData = [];
      }
      // 清除 所有勾选项
      multipleTableRef.value.clearSelection();
      // 当表格数据都没有被勾选的时候 就返回
      // 主要用于将当前勾选的表格状态清除
      if (selection.length == 0) return;
      multipleTableRef.value.toggleRowSelection(row, true);
      data.selectData = [];
      data.selectData.push(toRaw(row));
    };
    // 取消
    const closeDialog = (e) => {
      lostFocus(e);
      if (data.selectData && data.selectData.length > 0) {
        ElMessageBox.confirm("将取消当前选中专业", "取消", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            data.selectData = [];
            data.tableData.forEach((item) => {
              multipleTableRef.value.toggleRowSelection(item, false);
            });
            data.tableDialog = false;
             emit("change-major", null);
          })
          .catch(() => {});
      } else {
        data.tableDialog = false;
      }
    };
    //确定选中
    const clickTrue = (e) => {
      lostFocus(e);
      if (data.selectData.length > 0) {
        emit("change-major", data.selectData[0]);
        data.tableDialog = false;
      } else {
        ElMessage.warning("请先选择院校所属专业");
      }
    };
    //更新列表 区别于搜索要请求第一页
    const updateList = () => {
      getMarjorData("");
    };
    // 获取列表
    const getMarjorData = (type) => {
      if (type == "search") {
        data.majorId = 0;
      }
      data.loading = true;
      const obj = {
        majorId: data.majorId,
        majorCategoryId: data.categoryValue || null,
        year: data.recentYear || null,
        name: data.nameInput || null,
        pageSize: 50,
      };
      getMajorPtSchoolList(obj)
        .then((result) => {
          
             if (result && result.code == 1) {
            const list = result.result;
            const dataList = toRaw(list);
            dataList.forEach((item) => {
              if (data.majorId == item.id) {
                data.selectData.push(item);
              }
            });
            data.tableData = dataList;
            // 初始化选中
            if (multipleTableRef.value) {
              setTimeout(function () {
                changeSelRow();
              }, 1000);
            }
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      multipleTableRef,
      yearChange,
      cellClass,
      openDialog,
      select,
      closeDialog,
      clickTrue,
      updateList,
      getMarjorData,
    };
  },
};
</script>
<style scoped>
.relevancy_btn {
  width:330px;
}
.table_dialog {
  position: relative;
  margin-bottom: 30px;
}
.table_dialog .bottomTool {
  position: absolute;
  bottom: -45px;
  right: 0;
}

.choose_bom {
  margin-top: 20px;
  line-height: 35px;
}
.select_red {
  color: red;
}
/* 深度选择器 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
}
</style>

